import { createAssetManagementClient } from '@/shared/api/client'
import { validateResponse, validateResponseIsOk } from '@/shared/api/validation'
import { z } from 'zod'
import { createWheelingInvoiceSchema } from '../schemas'

const client = createAssetManagementClient()

export const createWheelingInvoice = (invoiceDetails: z.infer<typeof createWheelingInvoiceSchema>) =>
    validateResponseIsOk(client.sendPost(`assets/${invoiceDetails.assetCode}/billing/invoices`, { data: createWheelingInvoiceSchema.parse(invoiceDetails)}))
.then((data) => {
})